import { render, staticRenderFns } from "./Homegroup.vue?vue&type=template&id=ff2b5a96&scoped=true&"
import script from "./Homegroup.vue?vue&type=script&lang=js&"
export * from "./Homegroup.vue?vue&type=script&lang=js&"
import style0 from "./Homegroup.vue?vue&type=style&index=0&id=ff2b5a96&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2b5a96",
  null
  
)

export default component.exports